import { create } from 'zustand'

export type CRMTaskCreatorModalData = {
  /** Task id in edit mode. */
  taskId?: number
} | null

type CRMTaskCreatorModal = {
  mode: 'create' | 'edit' | null
  open: boolean
  data: CRMTaskCreatorModalData
}

export type CRMToast = {
  open: boolean
  message: string
  severity: 'success' | 'error'
}

type CRMStore = {
  crmTaskCreatorModal: CRMTaskCreatorModal
  setCRMTaskCreatorModal: (crmTaskCreatorModal: CRMTaskCreatorModal) => void
  toast: CRMToast
  showToast: (message: string, severity?: CRMToast['severity']) => void
  closeToast: () => void
}

export const useCRMStore = create<CRMStore>(set => ({
  crmTaskCreatorModal: { mode: null, open: false, data: null },
  setCRMTaskCreatorModal: crmTaskCreatorModal => set({ crmTaskCreatorModal }),
  toast: { open: false, message: '', severity: 'success' },
  showToast: (message, severity = 'success') =>
    set({ toast: { open: true, message, severity } }),
  closeToast: () => set(state => ({ toast: { ...state.toast, open: false } })),
}))
